const initialState = { data: '', availibility:true };

export function teamAvailabilityReducer(state = initialState, action) {
    switch (action.type) {
        case "TEAMS_AVAILABLE":
            return {
                data: action.payload,
                availibility:true
            };
        case "NO_TEAMS_AVAILABLE":
            return {
                data: action.payload,
                availibility:false
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyse/saveTeam/availableTeams.reducer.js